/**
 * Created by vladislav on 29.10.2020
 */

const BaseBlockView = cc.Node.extend({
    ctor: function (block) {
        this._super();

        this.setAnchorPoint(0.5, 0.5);

        this.block = block;

        const styles = cleverapps.styles.BaseBlockView;

        this.setContentSize2(styles);
        this.setAnchorPoint(0.5, 0.5);

        this.setAlignment(BaseBlockView.alignInTheGrid(this.block.x, this.block.y));

        this.setCascadeOpacityEnabled(true);

        this.setLocalZOrder(this.block.y);

        this.block.on("move", this.createListener(this.move.bind(this)));
        this.block.on("lose", this.createListener(this.lose.bind(this)));
        this.block.on("remove", this.createListener(() => {
            this.moveToBlock();
            this.removeFromParent();
        }));
        this.block.onLocateView = this.createListener(this.locateView.bind(this));

        this.setVisible(false);
    },

    locateView: function () {
        return this;
    },

    createFallAction: function (duration, pos) {
        return new cc.MoveTo(duration, pos).easing(cc.easeIn(2));
    },

    move: function (duration) {
        this.stopAllActions();
        this.moveToBlock();

        const pos = BaseBlockView.alignInTheGrid(this.block.x, this.block.y);
        this.runAction(this.createFallAction(duration, pos)).setFinalize(() => this.moveToKeypad());
    },

    lose: function () {
        const scene = cleverapps.Scenes.GetRunningScene();
        const pos = this.getParent().convertToNodeSpace(scene.convertToWorldSpace(cc.p(0, -2 * this.height)));

        this.stopAllActions();
        this.moveToBlock();
        this.runAction(new cc.Sequence(
            this.createFallAction(this.block.getLoseDuration(), cc.p(this.x, pos.y)),
            cleverapps.effects.fireAction("scramble.drop.lose")
        ));
    },

    showUp: function (silent) {
        if (silent) {
            this.setVisible(true);
            this.moveToKeypad();
            return;
        }

        const scene = cleverapps.Scenes.GetRunningScene();
        const pos = this.getParent().convertToNodeSpace(scene.convertToWorldSpace(cc.p(0, scene.height / 3)));
        const targetPos = BaseBlockView.alignInTheGrid(this.block.x, this.block.y);

        this.setAlignment(this.x, pos.y + this.y);
        this.setOpacity(0);
        this.setVisible(true);
        this.runAction(new cc.Sequence(
            new cc.Spawn(
                this.createFallAction(this.block.getShowUpDuration(), targetPos),
                new cc.FadeIn(0.4)
            ),
            cleverapps.effects.fireAction(this.effect)
        )).setFinalize(() => {
            this.setAlignment(targetPos);
            this.setOpacity(255);
            this.moveToKeypad();
        });
    },

    moveToBlock: function () {},
    moveToKeypad: function () {}
});

BaseBlockView.GetView = function (block) {
    return block.onLocateView();
};

BaseBlockView.CreateView = function (block) {
    const ViewClass = block.getViewClass();
    return new ViewClass(block);
};

BaseBlockView.alignInTheGrid = function (col, row) {
    return cc.p((col + 0.5) * cleverapps.styles.BaseBlockView.width, (row + 0.5) * cleverapps.styles.BaseBlockView.height);
};

cleverapps.styles.BaseBlockView = {
    width: 100,
    height: 98
};